module.exports = __webpack_public_path__ + "images/sales_contact_suggestion/phone_66224c1f93ad8ba719d06fe869b20cf7.svg";